import { render } from "./a_biccs.vue?vue&type=template&id=2a19f61a"
import script from "./a_biccs.vue?vue&type=script&lang=js"
export * from "./a_biccs.vue?vue&type=script&lang=js"

import "./a_biccs.vue?vue&type=style&index=0&id=2a19f61a&lang=less"
script.render = render

export default script